import { OptionsTypeItem } from "../../../../../common/models/Options";
import { PlanningConstant } from "../../../core/_constant";
import style from "./style.module.scss";
import { RiDeleteBin5Line } from "react-icons/ri";

import { IoIosAdd } from "react-icons/io";
import { useContext } from "react";
import { MaterialRequestContext } from "../../../core/_context";
import {
  capitalizeFirstLetter,
  getLastElementSplited,
} from "../../../../../utilities/string";
import { InputSelect } from "../../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../../utilities/API_URLs";
import { Input, InputNumber } from "antd";
import { ExportPdf } from "../../../../../common/components/Export/ExportPdf";
import { OperationContext } from "../CreateOperation";

enum TYPE_ITEM {
  MACHINE = "MACHINE",
  GRUE = "CRANE",
  LIFTING = "LIFTING",
}

type EventType = {
  value: any;
  name: string;
  index: number;
  materialType: string;
  type: string;
};

export const MaterialTransportAndLiftingForm = () => {
  const {
    materials,
    onAddMaterialItem,
    onDeleteMaterialItem,
    handleChangeItem,
    selectedMaterials,
    isDisableForm,
  } = useContext(MaterialRequestContext);
  const { initialValue, filter } = useContext(OperationContext);

  const operationId = initialValue?.id;

  const handleClickOnAdd = (type: any, materialType: string) => {
    onAddMaterialItem(
      `materials${capitalizeFirstLetter(materialType.toLowerCase())}${type}`
    );
  };

  const handleClickOndeDelete = (
    type: any,
    materialType: string,
    index: number
  ) => {
    const keyName = `materials${capitalizeFirstLetter(
      materialType.toLowerCase()
    )}${type}`;
    onDeleteMaterialItem(keyName, index);
  };

  const handleChange = (event: EventType) => {
    const { materialType, type, index, value, name } = event;
    const keyName = `materials${capitalizeFirstLetter(
      materialType.toLowerCase()
    )}${type}`;

    if (name === "type") {
      handleChangeItem(index, keyName, {
        material: null,
      });
    }
    handleChangeItem(index, keyName, {
      [name]: value,
    });
  };

  return (
    <div className={style.material_request__container}>
      {PlanningConstant.MATERIAL_REQUEST_TYPE.map(
        (item: OptionsTypeItem, i: number) => (
          <div className={style.material_request__item_container} key={i}>
            <div className={style.material_request__title_container}>
              <div className={style.material_request__title}>
                <span> {` MATÉRIELS ${item.label} `} </span>
              </div>
              {item.value === PlanningConstant.MATERIAL_REQUEST_COMAMA ? (
                <ExportPdf
                  uri={`/api/operations/${initialValue?.id}/TRANSPORT_AND_LIFTING/COMAMA/pdf`}
                  params={{
                    materialsCreatedAt: filter?.teamsCreatedAt,
                  }}
                />
              ) : (
                ""
              )}
            </div>

            {/* MACHINE  */}
            <div className={style.material_request__item_content}>
              <div className={style.material_request__table_content}>
                <table className={style.material_request__table}>
                  <thead>
                    <tr>
                      <th className={style.material_request__label}>
                        <div className={style.material_request__label_item}>
                          Machine{" "}
                        </div>
                      </th>
                      <th className={style.material_request__label}>
                        <div className={style.material_request__label_item}>
                          Liste de machine(s) demandée(s)
                        </div>
                      </th>
                      {/* {item?.value ===
                      PlanningConstant?.MATERIAL_REQUEST_SEMS ? ( */}
                        <th className={style.material_request__label}>
                          <div className={style.material_request__label_item}>
                            Conducteur{" "}
                          </div>
                        </th>
                      {/* ) : (
                        ""
                      )} */}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {materials?.[`materialsMachine${item.label}`]?.map(
                      (elem: any, key: number) => {
                        return (
                          <tr>
                            <td>
                              {" "}
                              <InputSelect
                                className={style.material_request__select}
                                value={elem?.type}
                                uri={
                                  API_URLs.materials
                                    .getMachineMaterialTypeSelect
                                }
                                disabled={isDisableForm}
                                allowClear={false}
                                onChange={(value) => {
                                  handleChange({
                                    value,
                                    name: "type",
                                    index: key,
                                    type: item?.value as string,
                                    materialType: TYPE_ITEM.MACHINE,
                                  });
                                }}
                              />
                            </td>
                            <td>
                              <InputSelect
                                className={style.material_request__select}
                                value={elem?.material}
                                disabled={!elem.type || isDisableForm}
                                uri={
                                  API_URLs.materials.machine.getMachineForSelect
                                }
                                allowClear={false}
                                excludedValue={selectedMaterials}
                                onChange={(value) => {
                                  handleChange({
                                    value,
                                    name: "material",
                                    index: key,
                                    type: item?.value as string,
                                    materialType: TYPE_ITEM.MACHINE,
                                  });
                                }}
                                valueOption={{
                                  labelKey: "reference",
                                  valueKey: "@id",
                                  title:
                                    item?.value === PlanningConstant?.MATERIAL_REQUEST_SEMS
                                      ? "driver"
                                      : "comamaDriverName",
                                }}
                                {...(elem?.type
                                  ? {
                                      params: {
                                        materialFrom: item?.value,
                                        machineMaterialType:
                                          getLastElementSplited(
                                            elem?.type?.value,
                                            "/"
                                          ),
                                        excludeOperation: operationId,
                                        materialsCreatedAt:
                                          filter?.teamsCreatedAt,
                                      },
                                    }
                                  : "")}
                              />
                              {elem?.error ? (
                                <span className={style.material_request__error}>
                                  Ce champ est requis{" "}
                                </span>
                              ) : (
                                ""
                              )}
                            </td>

                            {item?.value ===
                            PlanningConstant?.MATERIAL_REQUEST_SEMS ? (
                              <td>
                                <Input
                                  disabled
                                  value={elem?.material?.title?.fullname}
                                />
                              </td>
                            ) : (
                              <td>
                                <Input
                                  disabled
                                  value={elem?.material?.title}
                                />
                              </td>
                            )}
                            <td>
                              {!isDisableForm ? (
                                <RiDeleteBin5Line
                                  className={
                                    style.material_request__delete_icon
                                  }
                                  title="Supprimer"
                                  onClick={() =>
                                    handleClickOndeDelete(
                                      item.value,
                                      TYPE_ITEM.MACHINE,
                                      key
                                    )
                                  }
                                />
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
                <button
                  className={style.material_request__add_btn}
                  style={{
                    cursor: isDisableForm ? "not-allowed" : "pointer",
                  }}
                  disabled={isDisableForm}
                  onClick={() =>
                    handleClickOnAdd(item.value, TYPE_ITEM.MACHINE)
                  }
                >
                  <IoIosAdd className={style.material_request__add_icon} />
                  Ajouter
                </button>
              </div>
            </div>

            {/* GRUE  */}
            <div className={style.material_request__item_content}>
              <div className={style.material_request__table_content}>
                <table className={style.material_request__table}>
                  <thead>
                    <tr>
                      <th className={style.material_request__label}>
                        <div className={style.material_request__label_item}>
                          Type de Grue
                        </div>
                      </th>
                      <th className={style.material_request__label}>
                        <div className={style.material_request__label_item}>
                          Listes de grue(s) demandée(s)
                        </div>
                      </th>
                      {/* {item?.value ===
                      PlanningConstant?.MATERIAL_REQUEST_SEMS ? ( */}
                        <th className={style.material_request__label}>
                          <div className={style.material_request__label_item}>
                            Conducteur{" "}
                          </div>
                        </th>
                      {/* ) : (
                        ""
                      )} */}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {materials?.[`materialsCrane${item.label}`]?.map(
                      (elem: any, key: number) => (
                        <tr>
                          <td>
                            {" "}
                            <InputSelect
                              className={style.material_request__select}
                              value={elem?.type}
                              uri={
                                API_URLs.materials.getCraneMaterialTypeSelect
                              }
                              disabled={isDisableForm}
                              // valueOption={{
                              //   labelKey: "reference",
                              //   valueKey: "@id",
                              // }}
                              onChange={(value) => {
                                handleChange({
                                  value,
                                  name: "type",
                                  index: key,
                                  type: item?.value as string,
                                  materialType: TYPE_ITEM.GRUE,
                                });
                              }}
                            />
                          </td>
                          <td>
                            <InputSelect
                              className={style.material_request__select}
                              value={elem?.material}
                              disabled={!elem.type || isDisableForm}
                              uri={API_URLs.materials.grue.getGrueForSelect}
                              excludedValue={selectedMaterials}
                              onChange={(value) => {
                                handleChange({
                                  value,
                                  name: "material",
                                  index: key,
                                  type: item?.value as string,
                                  materialType: TYPE_ITEM.GRUE,
                                });
                              }}
                              valueOption={{
                                labelKey: "reference",
                                valueKey: "@id",
                                title:
                                  item?.value === PlanningConstant?.MATERIAL_REQUEST_SEMS
                                    ? "driver"
                                    : "comamaDriverName",
                              }}
                              {...(elem?.type
                                ? {
                                    params: {
                                      materialFrom: item?.value,
                                      craneMaterialType: getLastElementSplited(
                                        elem?.type?.value,
                                        "/"
                                      ),
                                      excludeOperation: operationId,
                                      materialsCreatedAt:
                                        filter?.teamsCreatedAt,
                                    },
                                  }
                                : "")}
                            />
                            {elem?.error ? (
                              <span className={style.material_request__error}>
                                Ce champ est requis{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                          {item?.value ===
                          PlanningConstant?.MATERIAL_REQUEST_SEMS ? (
                            <td>
                              <Input
                                disabled
                                value={elem?.material?.title?.fullname}
                              />
                            </td>
                          ) : (
                            <td>
                                <Input
                                  disabled
                                  value={elem?.material?.title}
                                />
                              </td>
                          )}
                          <td>
                            {!isDisableForm ? (
                              <RiDeleteBin5Line
                                className={style.material_request__delete_icon}
                                title="Supprimer"
                                onClick={() =>
                                  handleClickOndeDelete(
                                    item.value,
                                    TYPE_ITEM.GRUE,
                                    key
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                <button
                  className={style.material_request__add_btn}
                  style={{
                    cursor: isDisableForm ? "not-allowed" : "pointer",
                  }}
                  disabled={isDisableForm}
                  onClick={() => handleClickOnAdd(item.value, TYPE_ITEM.GRUE)}
                >
                  <IoIosAdd className={style.material_request__add_icon} />
                  Ajouter
                </button>
              </div>
            </div>
            {/* LEVAGE  */}
            <div className={style.material_request__item_content}>
              <div className={style.material_request__table_content}>
                <table className={style.material_request__table}>
                  <thead>
                    <tr>
                      <th className={style.material_request__label}>
                        <div className={style.material_request__label_item}>
                          Accessoire de levage
                        </div>
                      </th>
                      <th className={style.material_request__label}>
                        <div className={style.material_request__label_item}>
                          Référence du matériel
                        </div>
                      </th>
                      <th className={style.material_request__label}>
                        <div className={style.material_request__label_item}>
                          Quantité{" "}
                        </div>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {materials?.[`materialsLifting${item.label}`]?.map(
                      (elem: any, key: number) => (
                        <tr>
                          <td>
                            {" "}
                            <InputSelect
                              className={style.material_request__select}
                              value={elem?.type}
                              disabled={isDisableForm}
                              uri={
                                API_URLs.materials.getLiftingMaterialTypeSelect
                              }
                              onChange={(value) => {
                                handleChange({
                                  value,
                                  name: "type",
                                  index: key,
                                  type: item?.value as string,
                                  materialType: TYPE_ITEM.LIFTING,
                                });
                              }}
                            />
                          </td>
                          <td>
                            <InputSelect
                              className={style.material_request__select}
                              value={elem?.material}
                              disabled={!elem.type || isDisableForm}
                              uri={
                                API_URLs.materials.levage.getLiftingForSelect
                              }
                              excludedValue={selectedMaterials}
                              onChange={(value) => {
                                handleChange({
                                  value,
                                  name: "material",
                                  index: key,
                                  type: item?.value as string,
                                  materialType: TYPE_ITEM.LIFTING,
                                });
                              }}
                              valueOption={{
                                labelKey: "reference",
                                valueKey: "@id",
                                title: "materialUnit",
                              }}
                              {...(elem?.type
                                ? {
                                    params: {
                                      materialFrom: item?.value,
                                      liftingMaterialType:
                                        getLastElementSplited(
                                          elem?.type?.value,
                                          "/"
                                        ),
                                      excludeOperation: operationId,
                                      materialsCreatedAt:
                                        filter?.teamsCreatedAt,
                                    },
                                  }
                                : "")}
                            />
                            {elem?.error ? (
                              <span className={style.material_request__error}>
                                Ce champ est requis{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <InputNumber
                                min={0}
                                className="w-100"
                                value={elem?.quantity}
                                disabled={isDisableForm}
                                onChange={(value) => {
                                  handleChange({
                                    value,
                                    name: "quantity",
                                    index: key,
                                    type: item?.value as string,
                                    materialType: TYPE_ITEM.LIFTING,
                                  });
                                }}
                              />
                              {elem?.material?.title?.name ? (
                                <span className={style.material_request__label}>
                                  {" "}
                                  ({elem?.material?.title?.name}){" "}
                                </span>
                              ) : (
                                <div className=""></div>
                              )}
                            </div>
                            {elem?.error ? (
                              <span className={style.material_request__error}>
                                Ce champ est requis{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            {!isDisableForm ? (
                              <RiDeleteBin5Line
                                className={style.material_request__delete_icon}
                                title="Supprimer"
                                onClick={() =>
                                  handleClickOndeDelete(
                                    item.value,
                                    TYPE_ITEM.LIFTING,
                                    key
                                  )
                                }
                              />
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                <button
                  className={style.material_request__add_btn}
                  style={{
                    cursor: isDisableForm ? "not-allowed" : "pointer",
                  }}
                  disabled={isDisableForm}
                  onClick={() =>
                    handleClickOnAdd(item.value, TYPE_ITEM.LIFTING)
                  }
                >
                  <IoIosAdd className={style.material_request__add_icon} />
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};
